import { render, staticRenderFns } from "./wx-template-config.vue?vue&type=template&id=f1097a82&scoped=true"
import script from "./wx-template-config.vue?vue&type=script&lang=js"
export * from "./wx-template-config.vue?vue&type=script&lang=js"
import style0 from "./wx-template-config.vue?vue&type=style&index=0&id=f1097a82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1097a82",
  null
  
)

export default component.exports